var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12c0 .5-.5 1-1 1h-6v6c0 .5-.5 1-1 1s-1-.5-1-1v-6H5c-.5 0-1-.5-1-1s.5-1 1-1h6V5c0-.5.5-1 1-1s1 .5 1 1v6h6c.5 0 1 .5 1 1z"
  })));
}

export default SvgIconAdd;